import { render, staticRenderFns } from "./PartDetail.vue?vue&type=template&id=faa9afa8"
import script from "./PartDetail.vue?vue&type=script&lang=js"
export * from "./PartDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports